import { is99 } from '@/utils/common/env'
const bapiUrlIn99 = 'https://b.99app.com'
const bapiUrlInSSL = 'https://b.didi-food.com'
const baseApi = is99 ? bapiUrlIn99 : bapiUrlInSSL

export default {
  NODE_ENV: process.env.NODE_ENV,
  LOGIN_URL: 'https://page.didiglobal.com/public-biz/pc-login/3.0.1/index.html',
  BASE_API: baseApi,
}
